<template>
  <div>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration basic padd">
          <hr class="blue" />
          <h4>Vaši osnovni podatki</h4>

          <form action="#" class="custom-form">
            <div class="form-group">
              <input type="text" class="form-control" name="name" id="name" />
              <label for="name" class="animated-label">Ime</label>
              <span class="line"></span>
            </div>

            <div class="form-group">
              <input type="text" class="form-control" name="surname" id="surname" />
              <label for="surname" class="animated-label">Priimek</label>
              <span class="line"></span>
            </div>

            <div class="flex birthSex">
              <div class="form-group">
                <input type="text" class="form-control date" name="date" id="date" />
                <label for="date" class="animated-label">Datum rojstva</label>
                <span class="line"></span>
              </div>
              <p class="form-row flex sex">
                <label>Spol</label>
                <span class="shadow hoverEffect error female">
                  <span class="effect"></span>
                  <small class="icon warpit_icon_Female"></small>
                </span>
                <span class="shadow hoverEffect active male">
                  <span class="effect"></span>
                  <small class="icon warpit_icon_Male"></small>
                </span>
              </p>
            </div>
            <span class="errorSexTxt">Prosimo označite spol!</span>

            <div class="next flex">
              <a
                class="txt"
                href="https://studiolev.si/warp-panel/on_board_registration_two.html"
              >Prejšnji korak</a>
              <a
                class="join smallFont disabled hoverEffect"
                href="https://studiolev.si/warp-panel/on_board_address.html"
              >
                <label>Naslednji korak</label>
                <span class="effect"></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      notCompleted: true,
    };
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>
<style>
</style>